import { actions } from "../../actions/notifications/notifications";
import { NetworkHelpers as Network } from '../../helpers';

export default function notifications( state, action ) {
    
    if( !state ) {
        return {
            jobs: {},
            forums: {},
            messages: [],
        };
    }

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_JOB_NOTIFICATIONS: return setJobNotifications( newState, action );
        case actions.SET_FORUM_NOTIFICATIONS: return setForumNotifications( newState, action );
        case actions.SET_MESSAGING_NOTIFICATIONS: return setMessageNotifications( newState, action.messages );
        default: return newState;
    }
}

function setJobNotifications( newState, action ) {

    const notifications = { ...newState.jobs };
    
    let network = Network.setCurrentNetwork( action.networkId );
    
    notifications[ network ] = action.jobs;

    newState.jobs = notifications;
    
    return newState;
}

function setForumNotifications( newState, action ) {

    const notifications = { ...newState.forums };

    let network = Network.setCurrentNetwork( action.networkId );

    notifications[ network ] = action.forums;

    newState.forums = notifications;

    return newState;
}

function setMessageNotifications( newState, messages ) {
    newState.messages = messages;

    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/notifications/notifications.js